import { TextField } from 'src/components/TextField';

interface CouponFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const CouponFilter: React.FC<CouponFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  if (valueOnly) {
    return <>{value || ''}</>;
  }

  return (
    <TextField
      label={label}
      value={value || ''}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Enter Coupon Code"
    />
  );
};
